import { createFileRoute, redirect } from "@tanstack/react-router";

import { PATH_REDIRECTS } from "@/routing/pathRedirects";

export const Route = createFileRoute("/_app/proxy/")({
  beforeLoad: () => {
    throw redirect({ to: PATH_REDIRECTS.get("/proxy") as string });
  },
});
